import { render } from "./location.vue?vue&type=template&id=0e8b9b35&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=0e8b9b35&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e8b9b35"

export default script